import { styled } from "./styled";
/**
 * Surface
 * Provides background and foreground color
 */
export const Surface = styled('div', ({ color, $theme }) => ({
    background: $theme[color],
    color: $theme.foreground
}));
export const Card = styled(Surface, {
    padding: 20,
    borderRadius: 10
}, {
    color: "background3"
});
